export default __webpack_public_path__ + "static/media/nfg-redemption.8a368e4b.jpeg";